export const LANG_DELTA_RULE: ValidationRule = {
  id: 'jps-lang_delta',
  strict: true,
  fields: {}
}
export const LANG_STRING_RULE: ValidationRule = {
  id: 'jps-lang_string',
  strict: true,
  fields: {
    ja: {
      field: 'ja',
      type: 'string',
      mandatory: false
    },
    en: {
      field: 'en',
      type: 'string',
      mandatory: false
    }
  }
}
export const LANG_STRING_YOMI_RULE: ValidationRule = {
  id: 'jps-lang_string_yomi',
  strict: true,
  fields: {
    yomi: {
      field: 'yomi',
      type: 'string',
      mandatory: false
    }
  }
}
export const IMAGE_SELECTION_RULE: ValidationRule = {
  id: 'jps-image_selection',
  strict: true,
  fields: {
    url: {
      field: 'url',
      type: 'string',
      mandatory: false,
      label: {
        ja: '画像URL',
        en: 'Image URL'
      }
    },
    thumbnailUrl: {
      field: 'thumbnailUrl',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'サムネイルURL',
        en: 'Thumbnail URL'
      }
    },
    contentId: {
      field: 'contentId',
      type: 'string',
      mandatory: false
    },
    imageId: {
      field: 'imageId',
      type: 'string',
      mandatory: false
    },
    itemId: {
      field: 'itemId',
      type: 'string',
      mandatory: false
    },
    itemIndex: {
      field: 'itemIndex',
      type: 'string',
      mandatory: false
    },
    manifestUrl: {
      field: 'manifestUrl',
      type: 'string',
      mandatory: false
    },
    infoJsonUrl: {
      field: 'infoJsonUrl',
      type: 'string',
      mandatory: false
    },
    x: {
      field: 'x',
      type: 'number',
      mandatory: false,
      numIntOnly: true
    },
    y: {
      field: 'y',
      type: 'number',
      mandatory: false,
      numIntOnly: true
    },
    w: {
      field: 'w',
      type: 'number',
      mandatory: false,
      numIntOnly: true
    },
    h: {
      field: 'h',
      type: 'number',
      mandatory: false,
      numIntOnly: true
    },
    rotation: {
      field: 'rotation',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-image_rotation',
      label: {
        ja: '画像の回転',
        en: 'Image Rotation'
      }
    },
    cover: {
      field: 'cover',
      type: 'bool',
      mandatory: false,
      label: {
        ja: 'カバー表示',
        en: 'Cover Mode'
      }
    },
    title: {
      field: 'title',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'タイトル',
        en: 'Title'
      }
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明',
        en: 'Description'
      }
    },
    contentsRightsType: {
      field: 'contentsRightsType',
      type: 'string',
      mandatory: false,
      codeKey: 'jps-rights_type',
      label: {
        ja: '権利区分',
        en: 'Rights'
      }
    },
    contentsRights: {
      field: 'contentsRights',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      allowHTML: [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'a',
        'div',
        'p',
        'i',
        'b',
        'em',
        'blockquote',
        'strong',
        'br',
        'ul',
        'ol',
        'li'
      ],
      objRuleName: 'jps-lang_string',
      label: {
        ja: '権利表示',
        en: 'Attribution'
      }
    },
    source: {
      field: 'source',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '出典',
        en: 'Source'
      }
    },
    sourceUrl: {
      field: 'sourceUrl',
      type: 'string',
      mandatory: false,
      label: {
        ja: '出典URL',
        en: 'Source URL'
      }
    }
  }
  , enums: {
    'jps-image_rotation': IMAGE_ROTATION_DEF
  }
}
export const RECT_RULE: ValidationRule = {
  id: 'jps-rect',
  strict: true,
  fields: {
    x: {
      field: 'x',
      type: 'number',
      mandatory: false,
      numIntOnly: true,
      label: {
        ja: '左上X座標',
        en: 'Upper Left X'
      }
    },
    y: {
      field: 'y',
      type: 'number',
      mandatory: false,
      numIntOnly: true,
      label: {
        ja: '左上Y座標',
        en: 'Upper Left Y'
      }
    },
    w: {
      field: 'w',
      type: 'number',
      mandatory: false,
      numIntOnly: true,
      label: {
        ja: '幅',
        en: 'Width'
      }
    },
    h: {
      field: 'h',
      type: 'number',
      mandatory: false,
      numIntOnly: true,
      label: {
        ja: '高さ',
        en: 'Height'
      }
    }
  }
}
export const LAT_LON_RULE: ValidationRule = {
  id: 'jps-lat_lon',
  strict: true,
  fields: {
    lat: {
      field: 'lat',
      type: 'number',
      mandatory: true,
      label: {
        ja: '緯度',
        en: 'Latitude'
      }
    },
    lon: {
      field: 'lon',
      type: 'number',
      mandatory: true,
      label: {
        ja: '経度',
        en: 'Longitude'
      }
    }
  }
}
